import { render, staticRenderFns } from "./BankHolidays.vue?vue&type=template&id=31383768&scoped=true"
import script from "./BankHolidays.vue?vue&type=script&lang=js"
export * from "./BankHolidays.vue?vue&type=script&lang=js"
import style0 from "./BankHolidays.vue?vue&type=style&index=0&id=31383768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31383768",
  null
  
)

export default component.exports